import { EstateAgentUserDTO } from 'api/services/Agent/types'
import { AgentStatusEnum } from 'types/enums'

export const agentTemplate: EstateAgentUserDTO = {
  estateAgent: {
    entityStatus: AgentStatusEnum.Inactive,
    attachments: [],
    cInfos: [
      {
        contactName: '',
        defaultContactInfo: true,
        defaultValue: null,
        description: '',
        email: '',
        externalId: '',
        id: null,
        landLineNumber: '',
        extraNumber: '',
        mobileNumber: '',
        locale: 'el',
        location: {
          id: null,
          addresses: [
            {
              area: '',
              city: '',
              country: '',
              id: null,
              locale: 'el',
              postalCode: '',
              street: '',
              streetNumber: '',
            },
          ],
        },
        socialMediaInfo: [],
      },
    ],
    comments: '',
    companyName: [],
    companyTitle: [],
    description: '',
    externalId: '',
    id: null,
    estateAgentSystem: 'NONE',
    companyCommercialId: '',
    vatNumber: '',
  },
  user: {
    username: null,
    password: null,
    person: {
      id: null,
      firstName: null,
      lastName: null,
      cinfo: {
        id: null,
        email: null,
      },
    },
  },
}
